import type { Country } from "@tandemdiabetes/sugarmate-api-react-client"
import { createContext } from "react"

export interface CountrySelectionContextValue {
  country?: Country;
  countryCode: string;
  setCountryCode: (s: string) => void;
  hasUserConfirmedCountrySelection: boolean;
  confirmCountrySelection: () => void;
}

export const CountrySelectionContext = createContext<CountrySelectionContextValue | null>(null)
